<template>
  <custom-form action="api/v1/cryptoRates" method="post" @submitted="$emit('rateCreated', $event)">
    <custom-select
      name="crypto_country_id"
      class="form-group"
      label="Crypto Country"
      :items="cryptoCountries"
    />
    <custom-select
      name="local_currency_id"
      class="form-group"
      label="Local Currency"
      :items="traditionalCurrencyOptions"
    />
    <custom-select
      name="crypto_currency_id"
      class="form-group"
      label="Crypto Currency"
      :items="cryptoCurrencyOptions"
    />
    <custom-select
      name="reference_currency_id"
      class="form-group"
      label="Reference Currency"
      :items="traditionalCurrencyOptions"
    />
    <custom-input name="reference_to_local_rate" label="Reference to local Rate" />

    <custom-input name="reference_to_crypto_rate" label="Reference to crypto Rate" />

    <custom-input name="min_crypto_amount" label="Minimum Crypto Amount" />

    <custom-input name="max_crypto_amount" label="Maximum Crypto Amount" />

    <custom-button color="primary" large raised tile block>
      Create Rate
    </custom-button>
  </custom-form>
</template>
<script>
export default {
  data() {
    return {
      currencies: {
        crypto: [],
        traditional: [],
      },
      countries: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    cryptoCountries() {
      return this.getSelectOptions(this.countries);
    },
    traditionalCurrencyOptions() {
      return this.getSelectOptions(this.currencies.traditional);
    },
    cryptoCurrencyOptions() {
      return this.getSelectOptions(this.currencies.crypto);
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    fetchData() {
      this.$http.get("/api/v1/currencies").then((currencies) => {
        this.currencies = currencies;
      });
      this.$http.get("/api/v1/transactions/cryptoCountries").then(({ data }) => {
        this.countries = data;
      });
    },
  },
};
</script>
